export default {
  LOGIN: 'auth/login/',
  REGISTER: 'auth/register/',
  CHANGE_PASSWORD: 'auth/reset/change-password/',
  RESET_PASSWORD: 'auth/reset/send/',
  VERIFY_PASSWORD_OTP: 'auth/reset/verify/',
  SET_NEW_PASSWORD: 'auth/reset/new/',
};
